import { State } from ".";

export const getIsLogInOpen = (state: State): boolean => state.ui.isLogInOpen;
